import { Pipe, PipeTransform } from "@angular/core";
import { take } from "lodash-es";

@Pipe({
	name: "take",
})
export class TakePipe implements PipeTransform {
	transform<T>(value: T[], count: number): T[] {
		return take<T>(value, count);
	}
}
